import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Runtime auth config (single fetch, module-cached). Lets auth pages hide/show
// the "Continue with Google" block based on the backend GOOGLE_AUTH_ENABLED flag
// WITHOUT a frontend rebuild — re-enabling Google is a pure flag flip.
let _cache = null;

export function useGoogleAuthEnabled() {
  // Returns null while loading, then a boolean. Disabled is the default, so a
  // null render shows nothing (no flash of the Google button before it's hidden).
  const [enabled, setEnabled] = useState(_cache);
  useEffect(() => {
    if (_cache !== null) {
      setEnabled(_cache);
      return;
    }
    api
      .get("/auth/config")
      .then(({ data }) => {
        _cache = !!data.google_auth_enabled;
        setEnabled(_cache);
      })
      .catch(() => {
        _cache = false;
        setEnabled(false);
      });
  }, []);
  return enabled;
}
